export type ParamSort =
  | 'date,desc' // 최신 거래순
  | 'date,asc' // 오래된 거래순
  | 'count,desc' // 높은 잔여 수량순, 높은 배정수량순
  | 'count,asc' // 낮은 잔여 수량순, 낮은 배정수량순
  | 'releaseDate,desc' // 최신 작품순
  | 'releaseDate,asc' // 오래된 작품순
  | 'untilDate,asc' // 종료 날짜 빠른순
  | 'untilDate,desc' // 종료 날짜 느린순
  | 'revenueRate,desc' // 수익률 높은순
  | 'revenueRate,asc' // 수익률 낮은순
  | 'createdDate,desc' // FIXME : 확인 후 sort 코드 통일 필요
  | 'createdDate,asc' // FIXME : 확인 후 sort 코드 통일 필요
  | 'ALL'
  | 'SAVE'
  | 'CHANGE'
  | 'EXTINCTION'

export const PARAM_SORT = {
  LATEST: 'date,desc', // 최신 거래순
  OLDEST: 'date,asc', // 오래된 거래순
  COUNT_HIGH: 'count,desc', // 높은 잔여 수량순, 높은 배정수량순
  COUNT_LOW: 'count,asc', // 낮은 잔여 수량순, 낮은 배정수량순
  RELEASE_DATE_LATEST: 'releaseDate,desc', // 최신 작품순
  RELEASE_DATE_OLDEST: 'releaseDate,asc', // 오래된 작품순
  UNTIL_DATE_LATEST: 'untilDate,asc', // 종료 날짜 빠른순
  UNTIL_DATE_OLDEST: 'untilDate,desc', // 종료 날짜 느린순
  REVENUE_RATE_HIGH: 'revenueRate,desc', // 수익률 높은순
  REVENUE_RATE_LOW: 'revenueRate,asc', // 수익률 낮은순
  DESC: 'createdDate,desc', // FIXME : 확인 후 sort 코드 통일 필요
  ASC: 'createdDate,asc', // FIXME : 확인 후 sort 코드 통일 필요
  // point
  ALL: 'ALL',
  SAVE: 'SAVE',
  CHANGE: 'CHANGE',
  EXTINCTION: 'EXTINCTION',
  // TODO: 금액 높은순/금액 낮은순
} as const

export const PARAM_SORT_KEYS = Object.keys(PARAM_SORT).reduce((accumulator, value) => {
  return { ...accumulator, [value]: value }
}, {}) as { [key in PARAM_SORT_TYPE]: PARAM_SORT_TYPE }

export type PARAM_SORT_TYPE = keyof typeof PARAM_SORT

export const PARAM_FILTER = {
  SALE: 'SALE',
  DEPOSIT: 'DEPOSIT',
  WITHDRAWAL: 'WITHDRAWAL',
  SETTLEMENT: 'SETTLEMENT',
  UNALLOCATED: 'UNALLOCATED',
  REFUND: 'REFUND',
} as const
